export const PLANS = ['basic', 'ai'];
export const FORMULAS = ['month', 'year'];

export const planIds = {
  month: {
    pro: { eur: 'StripeMonthlyProEur', usd: 'StripeMonthlyProUsd' },
    basic: { eur: 'StripeMonthlyBasicEur', usd: 'StripeMonthlyBasicUsd' },
    expert: { eur: 'StripeMonthlyExpertEur', usd: 'StripeMonthlyExpertUsd' },
    ai: { eur: 'StripeMonthlyAiEur', usd: 'StripeMonthlyAiUsd' },
  },
  life: {
    pro: { eur: 'StripeLifeProEur', usd: 'StripeLifeProUsd' },
    basic: { eur: 'StripeLifeBasicEur', usd: 'StripeLifeBasicUsd' },
    expert: { eur: 'StripeLifeExpertEur', usd: 'StripeLifeExpertUsd' },
  },
  year: {
    pro: { eur: 'StripeYearlyProEur', usd: 'StripeYearlyProUsd' },
    basic: { eur: 'StripeYearlyBasicEur', usd: 'StripeYearlyBasicUsd' },
    expert: { eur: 'StripeYearlyExpertEur', usd: 'StripeYearlyExpertUsd' },
    ai: { eur: 'StripeYearlyAiEur', usd: 'StripeYearlyAiUsd' },
  },
};
